var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilePdf = function SvgFilePdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1416 22.0123V16.6723C19.1416 16.3183 19.2823 15.9787 19.5326 15.7284C19.783 15.478 20.1225 15.3373 20.4766 15.3373H21.8116",
    stroke: "#363840",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1416 19.3425H21.1441",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99328 22.0125H3.32328C2.96922 22.0125 2.62965 21.8718 2.37929 21.6215C2.12893 21.3711 1.98828 21.0316 1.98828 20.6775V3.32249C1.98828 2.96842 2.12893 2.62886 2.37929 2.3785C2.62965 2.12814 2.96922 1.98749 3.32328 1.98749H12.7831C13.1369 1.98756 13.4762 2.12809 13.7265 2.3782L18.9526 7.60428C19.2027 7.85454 19.3432 8.19386 19.3433 8.54768V12.6675",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.343 8.66249H14.003C13.6489 8.66249 13.3093 8.52184 13.059 8.27148C12.8086 8.02111 12.668 7.68155 12.668 7.32749V1.98749",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.675V15",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H9.6675C10.1986 15 10.7079 15.211 11.0835 15.5865C11.459 15.9621 11.67 16.4714 11.67 17.0025C11.67 17.5336 11.459 18.0429 11.0835 18.4185C10.7079 18.794 10.1986 19.005 9.6675 19.005H9",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21.675C14.7081 21.675 15.3873 21.3937 15.888 20.893C16.3887 20.3923 16.67 19.7131 16.67 19.005V17.67C16.67 16.9619 16.3887 16.2827 15.888 15.782C15.3873 15.2813 14.7081 15 14 15V21.675Z",
    stroke: "#2E3330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFilePdf;